<template>
  <div id="printable">
    <div v-if="isDataLoading">
      {{ $t('pages.loading') }}
    </div>
    <v-table
      v-else
      :row-active-id="rowActiveId"
      :data="tableData"
      :columns="columns"
      clickable
      @row-click="onRowClick"
    >
      <template v-slot:column-time="item">
        <p
          v-if="item.row.isNew"
          :class="$style.new"
        >
          NEW
        </p>
        {{ item.row.date | dateTime }}
      </template>
      <template v-slot:column-caption="item">
        <span :class="$style.dangerous">
          <dangerous :value="item.row.statusDangerous" />
        </span>
        {{ item.row.caption }}
      </template>

      <template v-slot:column-keys="item">
        <span :class="$style.tableColumnText">{{ item.row.keys }}</span>
      </template>
    </v-table>
    <additional-list
      v-if="rowActiveId"
      :list="additionalList"
    />
  </div>
</template>

<script>
  import VTable from '@/components/common/table/table.vue';
  import AdditionalList from '@/components/common/logs/additional/list/index.vue';
  import Dangerous from '@/components/common/dangerous/index.vue';
  import { dateTime } from '@/helpers/filters';
  import { LogData } from '@/domains/log/data';

  import workerBasedRequestMixin from '@/components/common/logs/mixins/workerBasedRequestMixin';

  const stripKeysOffset = 100;

  function stripKeys(keys) {
    if (keys.length > stripKeysOffset + 3) {
      return `${keys.slice(0, stripKeysOffset)}...`;
    }

    return keys;
  }

  const filters = [
    (item) => dateTime(item.date), // Дата
    'caption', // Заголовок окна
    'path', // Путь к программе
    'username', // Имя пользователя
    'keys', // По возможности по содержимому KEYS.
  ];

  export default {
    components: {
      VTable,
      AdditionalList,
      Dangerous,
    },
    filters: {
      dateTime,
    },
    mixins: [workerBasedRequestMixin],
    data() {
      return {
        tableData: [],
        columns: [
          {
            field: 'time',
            title: this.$t('pages.columns.time'),
            sortFn: (isAsc) => (a, b) => (new Date(a.date) - new Date(b.date)) * (isAsc ? 1 : -1),
          },
          { field: 'caption', title: this.$t('pages.columns.caption') },
          { field: 'username', title: this.$t('pages.columns.username') },
          { field: 'keys', title: this.$t('pages.columns.text') },
        ],
      };
    },
    computed: {
      rowActiveId() {
        return parseInt(this.$route.params.record, 10);
      },
      activeRow() {
        const activeRow = this.pagedData.find((i) => i?.id === this.rowActiveId);

        return activeRow || {};
      },
      additionalList() {
        const row = this.activeRow;

        return [
          [this.$t('pages.columns.time'), dateTime(row.date)],
          [this.$t('pages.columns.caption'), row.caption],
          [this.$t('pages.columns.path'), row.path],
          [this.$t('pages.columns.text'), row.keys],
        ];
      },
    },
    watch: {
      '$route.query': function (query, oldQuery) {
        // eslint-disable-line func-names
        if (query.dateFrom !== oldQuery.dateFrom || query.dateTo !== oldQuery.dateTo) {
          this.fetch();
        }
        if (query.filter !== oldQuery.filter) {
          this.getTableData();
        }
      },
      pagedData() {
        this.getTableData();
      },
    },
    async created() {
      this.$store.commit('logs/printData/setColumns', this.columns);
      await this.fetch();
    },
    methods: {
      getTableData() {
        let items = [...this.pagedData];
        items = items.filter((element) => element !== undefined);

        if (items.length > 0) {
          const data = items.map((item) => ({
            ...item,
            keys: stripKeys(item.keys),
          }));

          this.tableData = LogData.filterTable(data, filters, this.$route.query.filter);
        }
      },
      onRowClick(id) {
        this.$router.push({
          name: 'computers-computer-log-record',
          params: { record: id },
          query: this.$route.query,
        });
      },
    },
  };
</script>

<style lang="scss" module>
  .new {
    display: inline-block;
    background: $light-blue;
    color: $blue;
    font-size: 7px;
    padding: 3px;
    margin-right: 8px;
    border-radius: 1px;
  }

  .dangerous {
    display: inline-block;
    margin-right: 8px;
  }
</style>
